import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiArrowLeft, FiGrid, FiUpload } from 'react-icons/fi';
import NPDDashboard from './NPDDashboard';
import NPDUpload from './NPDUpload';
import '../../Styles/NPD.css';

const TABS = [
  { id: 'dashboard', label: 'Dashboard', icon: <FiGrid size={15} /> },
  { id: 'upload', label: 'Upload', icon: <FiUpload size={15} /> },
];

const pageVariants = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.18, ease: 'easeIn' } },
};

const NPDApp = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderTab = () => {
    switch (activeTab) {
      case 'dashboard':
        return <NPDDashboard onNavigate={setActiveTab} />;
      case 'upload':
        return <NPDUpload />;
      default:
        return <NPDDashboard onNavigate={setActiveTab} />;
    }
  };

  return (
    <motion.div
      className="npd-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.35 }}
    >
      <motion.div
        className="npd-header"
        initial={{ y: -56, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="npd-header-left">
          <motion.button
            className="npd-back-btn"
            onClick={() => navigate('/home')}
            whileTap={{ scale: 0.95 }}
          >
            <FiArrowLeft size={15} />
            <span>Back to Home</span>
          </motion.button>
          <motion.div
            className="npd-header-title"
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.12, duration: 0.4 }}
          >
            <h1>NPD Drawing Assistant</h1>
            <p>Upload drawings, extract specs, and generate DXF</p>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        className="npd-tab-bar"
        initial={{ opacity: 0, y: -8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.18, duration: 0.35 }}
      >
        {TABS.map((tab, i) => (
          <motion.button
            key={tab.id}
            className={`npd-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.22 + i * 0.06 }}
            whileTap={{ scale: 0.96 }}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </motion.button>
        ))}
      </motion.div>

      <div className="npd-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            {renderTab()}
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default NPDApp;
